import React from "react";
import cx from "classnames";
import styles from "./styles.module.sass";
import { Link } from "react-router-dom";

interface Room {
  slug: string;
  name: string;
}

interface RoomGroupProps {
  category: string;
  rooms: Room[];
  country: string;
  base: number;
  active?: string;
}

const PUBLIC_URL = process.env.PUBLIC_URL ?? "";

const RoomGroup: React.FC<RoomGroupProps> = ({
  category,
  rooms,
  country,
  base,
  active = "",
}) => {
  const flexBasis = (rooms.length / base) * 100;

  return (
    <div
      className={styles.roomGroup}
      style={{ flexBasis: `${flexBasis}%` }}
    >
      <div className={styles.roomCategory}>{category}</div>
      <div className={styles.rooms}>
        {rooms.map((room) => (
          <Link
            key={room.slug}
            to={`${PUBLIC_URL}/${country}/rooms/${room.slug}`}
            className={cx(styles.buttonWrapper, {
              [styles.narrow]: base > 7,
              [styles.small]: base > 9,
            })}
          >
            <div
              className={cx(styles.room, {
                [styles.isActive]: active === room.slug,
              })}
            >
              {room.name}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default RoomGroup;
